<template>
  <div class="locations">
    <div class="container-fluid">
      <div>
        <h3 class="mb-3">المناطق</h3>
        <div class="locations__header d-flex">
          <div style="flex: 1">
            <el-input
              @input="searchInRegions"
              prefix-icon="el-icon-search"
              placeholder="بحث في المناطق"
              v-model="search"
            ></el-input>
          </div>
          <div>
            <el-button type="primary" @click="addRegionModel = true">
              إضافة
            </el-button>
          </div>
        </div>

        <div class="locations__body">
          <div class="row" v-if="regions.length > 0">
            <div class="col-md-4" v-for="region in regions" :key="region.id">
              <div class="d-flex locations__card justify-content-between">
                <div>
                  <div class="d-flex mb-3" style="gap: 15px">
                    <div>
                      <h6 class="locations__key">المنطقة</h6>
                    </div>
                    <div>
                      <h6 class="locations__value">
                        {{ region.name }}
                      </h6>
                    </div>
                  </div>
                  <div class="d-flex mb-3" style="gap: 15px">
                    <div>
                      <h6 class="locations__key">المدينة</h6>
                    </div>
                    <div>
                      <h6 class="locations__value">
                        {{ region.city.name }}
                      </h6>
                    </div>
                  </div>
                </div>
                <div class="locations__actions">
                  <div class="actions">
                    <div>
                      <button
                        @click="
                          (updateRegionModel = true),
                            (updateRegion = { ...region })
                        "
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          id="Icon"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                        >
                          <rect
                            id="Area"
                            width="20"
                            height="20"
                            fill="#fcfcfc"
                            opacity="0"
                          />
                          <g
                            id="Icon-2"
                            data-name="Icon"
                            transform="translate(1.566 1.566)"
                          >
                            <path
                              id="Path"
                              d="M9.167,3.333H15A1.667,1.667,0,0,1,16.667,5V16.667A1.666,1.666,0,0,1,15,18.333H3.334a1.667,1.667,0,0,1-1.667-1.666V10.833"
                              transform="translate(0.101 -1.566)"
                              fill="none"
                              stroke="#919efa"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.667"
                            />
                            <path
                              id="Path-2"
                              data-name="Path"
                              d="M9.684,2.083a1.768,1.768,0,0,0-2.5,2.5L15.1,12.5l3.333.833L17.6,10Z"
                              transform="translate(-6.667 -1.566)"
                              fill="none"
                              stroke="#919efa"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.667"
                            />
                          </g>
                        </svg>
                      </button>
                    </div>

                    <!-- <div>
                      <el-popconfirm
                        :title="'هل أنت متأكد من الحذف ؟'"
                        :cancel-button-text="'إلغاء'"
                        :confirm-button-text="'حذف'"
                      >
                        <button slot="reference">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            id="Icon"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                          >
                            <rect
                              id="Area"
                              width="20"
                              height="20"
                              fill="#fcfcfc"
                              opacity="0"
                            />
                            <g
                              id="Icon-2"
                              data-name="Icon"
                              transform="translate(2.5 1.667)"
                            >
                              <path
                                id="Path"
                                d="M17.5,5H2.5"
                                transform="translate(-2.5 -1.667)"
                                fill="none"
                                stroke="red"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.667"
                              />
                              <path
                                id="Path-2"
                                data-name="Path"
                                d="M4.167,5V16.667a1.666,1.666,0,0,0,1.666,1.666h8.334a1.666,1.666,0,0,0,1.666-1.666V5m-2.5,0V3.333a1.666,1.666,0,0,0-1.666-1.666H8.333A1.666,1.666,0,0,0,6.667,3.333V5"
                                transform="translate(-2.5 -1.667)"
                                fill="none"
                                stroke="red"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.667"
                              />
                              <line
                                id="Line"
                                y2="5"
                                transform="translate(9.167 7.5)"
                                fill="none"
                                stroke="red"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.667"
                              />
                              <line
                                id="Line-2"
                                data-name="Line"
                                y2="5"
                                transform="translate(5.833 7.5)"
                                fill="none"
                                stroke="red"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.667"
                              />
                            </g>
                          </svg>
                        </button>
                      </el-popconfirm>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="no-data-img" v-else>
            <NoData />
          </div>
        </div>
      </div>
    </div>

    <vs-popup
      class="popup-width-300"
      title="إضافة منطقة جديدة"
      :active.sync="addRegionModel"
    >
      <div class="popup-calender">
        <el-form :model="addRegion" ref="addRegion">
          <h6 class="mb-2">إختر المدينة</h6>
          <el-form-item
            prop="city_id"
            :rules="[{ required: true, message: 'المدينة مطلوبة' }]"
          >
            <el-select
              v-model="addRegion.city_id"
              placeholder="المدينة"
              style="width: 100% !important"
            >
              <el-option
                v-for="item in cities"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <h6 class="mb-2">المنطقة</h6>
          <el-form-item
            prop="name"
            :rules="[{ required: true, message: 'المنطقة مطلوبة' }]"
          >
            <el-input placeholder="المنطقة" v-model="addRegion.name"></el-input>
          </el-form-item>

          <el-form-item>
            <div>
              <el-button type="primary" @click="onSubmit('addRegion')">
                إضافة
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>

    <!-- Update -->

    <vs-popup
      class="popup-width-300"
      title="تعديل المنطقة"
      :active.sync="updateRegionModel"
    >
      <div class="popup-calender">
        <el-form :model="updateRegion" ref="updateRegion">
          <h6 class="mb-2">المدينة</h6>
          <el-form-item
            prop="city_id"
            :rules="[{ required: true, message: 'المدينة مطلوبة' }]"
          >
            <el-select
              v-model="updateRegion.city_id"
              placeholder="المدينة"
              style="width: 100% !important"
            >
              <el-option
                v-for="item in cities"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <h6 class="mb-2">المنطقة</h6>
          <el-form-item
            prop="name"
            :rules="[{ required: true, message: 'المنطقة مطلوبة' }]"
          >
            <el-input
              placeholder="المنطقة"
              v-model="updateRegion.name"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <div>
              <el-button type="primary" @click="onSubmitUpdate('updateRegion')">
                   حفظ التعديلات
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios";
import NoData from "@/components/NoData.vue";
export default {
  components: {
    NoData,
  },
  data() {
    return {
      regions: [],
      allRegions: [],
      cities: [],
      search: "",
      locations: [{ label: "cvv", value: "vd" }],
      addRegion: {},
      addRegionModel: false,
      updateRegionModel: false,
      updateRegion: {},
    };
  },
  created() {
    this.getRegions();
    this.getCities();
  },
  methods: {
    deleteLocation(regions) {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .delete(`/areas/${regions.id}`)
        .then(() => {
          this.$vs.notify({
            title: "تم بنجاح",
            position: "top-center",
            color: "success",
            text: "تم الحذف بنجاح",
          });
          this.getRegions();
        })
        .catch((err) => {
          if (err.response.status == 500) {
            this.$vs.notify({
              title: " عذرا",
              position: "top-center",
              color: "danger",
              text: "غير مسموح بحذف هذا العنصر",
            });
          }
        })
        .finally(() => loading.close());
    },
    searchInRegions() {
      // const loading = this.$loading({
      //   lock: true,
      //   text: false,
      //   spinner: "el-icon-loading",
      //   background: "rgba(255,255,255,.7)",
      //   customClass: "fullscreen-loading",
      // });
      this.regions = this.allRegions.filter((ele) => {
        return ele.name.includes(this.search);
      });
      // loading.close();
    },
    onSubmitUpdate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });
          axiosApi
            .put(`/areas/${this.updateRegion.id}`, this.updateRegion)
            .then(() => {
              this.updateRegionModel = false;
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم التعديل بنجاح",
              });
              this.getRegions();
            })
            .catch((err) => {
              if (err.response.status == 422) {
                this.$vs.notify({
                  time: 10000,
                  title: "حدث خطأ!",
                  position: "top-center",
                  color: "danger",
                  text: "هذه المنطقة موجودة من قبل",
                });
              }
            })
            .finally(() => loading.close());
        }
      });
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });
          axiosApi
            .post(`/areas`, this.addRegion)
            .then(() => {
              this.addRegionModel = false;
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم الإضافة بنجاح",
              });
              this.addRegion = {};
              this.getRegions();
            })
            .catch((err) => {
              if (err.response.status == 422) {
                this.$vs.notify({
                  time: 10000,
                  title: "حدث خطأ!",
                  position: "top-center",
                  color: "danger",
                  text: "هذه المنطقة موجودة من قبل",
                });
              }

              if (err.response.status == 400) {
                this.$vs.notify({
                  title: "هذه المدينة موجودة من قبل",
                  position: "top-center",
                  color: "danger",
                  text: "حدث خطا ما",
                });
              }
            })
            .finally(() => loading.close());
        }
      });
    },
    getCities() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .get(`/cities`)
        .then((res) => {
          this.cities = res.data;
        })
        .finally(() => loading.close());
    },
    getRegions() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .get(`/areas`)
        .then((res) => {
          this.regions = res.data;
          this.allRegions = [...res.data];
        })
        .finally(() => loading.close());
    },
  },
};
</script>

<style lang="scss">
.locations {
  padding: 10px;
  &__header {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 15px;
  }
  &__card {
    padding: 10px;
    justify-content: space-between;
    background: #fff;
    margin-bottom: 20px;
    h6 {
      font-size: 14px;
      margin-bottom: 0;
      margin-top: 5px;
    }
  }
  &__actions {
    .actions {
      gap: 10px;
      display: flex;
      margin-bottom: 10px;
      button {
        background: none;
        border: none;
        outline: none;
      }
    }
    .text-success {
      font-family: "CairoSemiBold";
    }
    .text-grey {
      text-decoration: line-through;
    }
  }

  &__key {
    background: #fafafa;
    padding: 7px 10px;
    border-radius: 8px;
    margin-bottom: 0;
    text-align: center;
  }
  &__value {
    margin-top: 5px;
    padding-top: 5px;
  }
}
</style>